import { PermissionsTypes } from 'enum/permissionsType'
import { IModeratorPermissionsModel } from 'models/moderatorPermissions.model'

export const emptyField: IModeratorPermissionsModel = {
  seeMonitor: false,
  editCourse: false,
  chat: false,
  downloadReports: false,
  approveRequests: false,
  monitoringAreas: false,
  manageCourses: false,
  index: 0,
  type: PermissionsTypes.profile,
}
